export const TRANSPARENT_IMAGE_URL =
  'https://assets8.cre.ma/m/widgets/transparent.png';
